module.exports = __webpack_public_path__ + "static/media/security_1.8c3734ae.png";